import { render, staticRenderFns } from "./NewPasswordPage.vue?vue&type=template&id=4c36e407&scoped=true"
import script from "./NewPasswordPage.vue?vue&type=script&lang=ts"
export * from "./NewPasswordPage.vue?vue&type=script&lang=ts"
import style0 from "./NewPasswordPage.vue?vue&type=style&index=0&id=4c36e407&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c36e407",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c36e407')) {
      api.createRecord('4c36e407', component.options)
    } else {
      api.reload('4c36e407', component.options)
    }
    module.hot.accept("./NewPasswordPage.vue?vue&type=template&id=4c36e407&scoped=true", function () {
      api.rerender('4c36e407', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/auth/NewPasswordPage.vue"
export default component.exports